import MemberCertificate from './MemberCertificate';

export default MemberCertificate;
